import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-start text-nowrap" }
const _hoisted_2 = { class: "text-nowrap" }
const _hoisted_3 = { class: "text-start" }
const _hoisted_4 = { class: "text-nowrap" }
const _hoisted_5 = { class: "text-gray-400" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { class: "text-start" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-gray-400" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-gray-400" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-gray-400" }
const _hoisted_15 = {
  key: 0,
  class: "text-end"
}
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-nowrap" }
const _hoisted_18 = {
  key: 1,
  class: "text-end"
}
const _hoisted_19 = { class: "text-nowrap gap-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_22 = { class: "d-flex flex-column gap-5" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "svg-icon svg-icon-2 svg-icon-warning" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["colspan"]
const _hoisted_28 = { class: "d-flex flex-column justify-content-center align-items-center h-60px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.items, (item, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "subtable_template routing-overview text-start border-dashed",
        key: index
      }, [
        _createElementVNode("td", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(item.fulfillment_order_number), 1)
        ]),
        _createElementVNode("td", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("orderAssign.assignDate")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDate(item.assigned_date)), 1)
        ]),
        _hoisted_6,
        _createElementVNode("td", _hoisted_7, [
          (item.fulfillment_type === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", null, _toDisplayString(item.__show.merchant_name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.__show.channel_type), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", null, _toDisplayString(item.__show.warehouse_name), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("salesOrderOverview.onHand")), 1)
              ]))
        ]),
        _createElementVNode("td", _hoisted_12, [
          (item.fulfillment_type === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.t("order.merchantRequestNo")), 1),
                (item.request_id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: _ctx.getMerchantOrderRoute(item) + item.request_id + '/overview',
                      class: "text-gray-400 text-hover-primary",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.request_number), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("td", _hoisted_13, [
          _createElementVNode("div", null, _toDisplayString(_ctx.t("order.qty")), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(item.qty), 1)
        ]),
        (!(_ctx.type === 1 && _ctx.isMB))
          ? (_openBlock(), _createElementBlock("td", _hoisted_15))
          : _createCommentVNode("", true),
        _createElementVNode("td", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.t("order.fulStatus")), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["fs-7", _ctx.statusClass(item.status)])
          }, _toDisplayString(item.__show.status), 3)
        ]),
        (!(_ctx.type === 1 && _ctx.isMB))
          ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                  default: _withCtx(() => [
                    (
              item.status === _ctx.FulfillmentOrderStatus.Initialized ||
              item.status === _ctx.FulfillmentOrderStatus.Assigning
            )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-sm btn-light flex",
                          onClick: ($event: any) => (_ctx.cancelItem(item.id)),
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modal_cancel_fulfillment_order"
                        }, [
                          _createElementVNode("span", _hoisted_21, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr088.svg" })
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.t("orderAssign.canceled")), 1)
                        ], 8, _hoisted_20))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("td", null, [
          (item.not_available_until || item.not_available_until_note)
            ? (_openBlock(), _createBlock(_component_el_popover, {
                key: 0,
                placement: "top",
                width: "auto",
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    (item.not_available_until)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.t("orderRequest.notAvailableUntilDate", [
                _ctx.customFormatDate(item.not_available_until, "DD.MM.YYYY"),
              ])), 1))
                      : _createCommentVNode("", true),
                    (item.not_available_until_note)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.not_available_until_note), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    (_ctx.formData.items.length == 0)
      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_26, [
          _createElementVNode("td", {
            colspan: _ctx.type === 1 && _ctx.isMB ? 8 : 10
          }, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.isRequest ? "No data found" : ""), 1)
          ], 8, _hoisted_27)
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}